import { EyewitnessPost, PostPetition } from "./api";
import { CommentPostData } from "./comment";

export interface PetitionProps {
  next: () => void;
  petition_data: PostPetition;
  setPetition_data: React.Dispatch<React.SetStateAction<PostPetition>>;
}
export interface PetitionPropsOne {
  cancel: () => void;
  next: () => void;
  petition_data: PostPetition;
  setPetition_data: React.Dispatch<React.SetStateAction<PostPetition>>;
}
export interface PetitionPropsTwo {
  prev: () => void;
  next: () => void;
  petition_data: PostPetition;
  setPetition_data: React.Dispatch<React.SetStateAction<PostPetition>>;
}

export interface EyewitnessOneProps {
  cancel: () => void;

  next: () => void;
  report_data: EyewitnessPost;
  setReport_data: React.Dispatch<React.SetStateAction<EyewitnessPost>>;
}

export interface EyewitnessProps {
  next: () => void;
  prev: () => void;
  report_data: EyewitnessPost;
  setReport_data: React.Dispatch<React.SetStateAction<EyewitnessPost>>;
}

export interface PostContentProps {
  id: number;
  title: string;
  context: string;
  post_type: string;
  author: string;
  author_id: number;
  created_at: string;
  media: any[];
  comments: number;
  likes: number;
  reposts: number;
  bookmarks: number;
}
export const PostContentPropsDummy = {
  id: 0,
  title: "",
  context: "",
  post_type: "",
  author: "",
  author_id: 0,
  created_at: "",
  media: [],
  comments: 0,
  likes: 0,
  reposts: 0,
  bookmarks: 0,
};

export interface PostContentDetails {
  id: number;
  title: string;
  context: string;
  post_type: string;
  author: string;
  author_badge: number;
  author_photo_url: string;
  author_id: number;
  created_at: string;
  media: any[];
  comments: number;
  likes: number;
  reposts: number;
  reported: any;
  bookmarks: number;
  signatures: number;
  target_signatures: number;
  target_representative: string;
  current_user_bookmarked: boolean;
  status: string;
}

export const PostContentDetailsDummy = {
  id: 0,
  title: "",
  context: "",
  post_type: "",
  author: "",
  author_photo_url: "",
  author_id: 0,
  author_badge: 0,
  created_at: "",
  media: [],
  comments: 0,
  likes: 0,
  reposts: 0,
  reported: null,
  bookmarks: 0,
  signatures: 0,
  target_signatures: 0,
  current_user_bookmarked: false,
  target_representative: "",
  status: "",
};
